import { Avatar, Clickable, Col, Row, ShoutoutsPage, Text } from 'components';
import { Api, closeNotifs, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ClickableBold = ({ onClick, children }) => (
  <Clickable onClick={onClick}>
    <Text bold>{children}</Text>
  </Clickable>
);

const ShoutoutReaction = ({ data }) => {
  const { sender, timestamp, entityId } = data,
    [visible, setVisible] = useState(false),
    navigate = useNavigate(),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    user = useSelector((state) => state.user),
    shoutout = user.sentShoutouts.find((x) => x._id === entityId);

  useEffect(() => {
    if (!shoutout) {
      getShoutout();
    }
  }, []);

  async function getShoutout() {
    const res = await Api.post('/shoutouts/get', { entityId });
    if (!res) return null;

    dispatch({
      type: 'ADD_SENT_SHOUTOUT',
      payload: res
    });
  }

  if (!sender) return null;

  return (
    <React.Fragment>
      <ShoutoutsPage visible={visible} setVisible={setVisible} user={user} data={[shoutout]} />

      <Clickable onClick={() => setVisible(true)}>
        <Row noFlex pad="0 0 16px" center>
          <Clickable
            onClick={() => {
              navigate(`/profile/${sender.username}`);
              closeNotifs(dispatch);
            }}
          >
            <Avatar small avatar={sender.avatar} user={sender} />
          </Clickable>

          <Col marg="0 0 0 16px">
            <Row between start>
              <Trans
                parent={Text}
                components={{
                  strong: (
                    <ClickableBold
                      onClick={() => {
                        navigate(`/profile/${sender.username}`);
                        closeNotifs(dispatch);
                      }}
                    />
                  )
                }}
              >
                {t('notifications.reactedToShoutout', { sender: sender.name || sender.username })}
              </Trans>

              <Text b2 med col={theme.GREY_60}>
                {timestamp}
              </Text>
            </Row>
          </Col>
        </Row>
      </Clickable>
    </React.Fragment>
  );
};

export default ShoutoutReaction;
